<template>
    <div class="top" :style="{ height: navHeight ? (navHeight + 'px !important') : '50px !important' }">
        <div class="titleMain"
            :style="{ height: navHeight ? (navHeight + 'px !important') : '50px !important', backgroundColor: bg ? bg : '#fff' }">
            <!-- <img class="bg" :src="bg" v-if="bg" alt=""> -->
            <div class="navTitle"
                :style="{ marginTop: navHeight ? (navHeight - 50 + 'px !important') : '0px !important' }">
                <div class="navTitleTop" :style="{ color: color }">
                    <!-- <div class="back">></div> -->
                    <Icon v-if="color" name="arrow-left" :size="20" @click="back" :color="color" />
                    <img v-else src="../../static/images/icon-back@2x.png" @click="back" alt="">
                    <span class="title">{{ title }}</span>
                    <span class="right" v-if="rightText" @click="clickRight">{{ rightText }}</span>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import native, { hasNativeBridge } from '@/utils/jsbridge'
import session from '@/utils/session'
import { Icon } from 'vant'
export default {
    name: 'Awaken',
    props: {
        title: {
            type: String,
            default: '我的赛事',
        },
        bg: {
            type: String,
            default: '',
        },
        rightText: {
            type: String,
            default: ""
        },
        color: {
            type: String,
            default: "#000"
        },
        forceRouterBack: {
            type: Boolean,
            default: false
        },
        backPath: {
            type: String,
            default: ''
        },
        backQuery: {
            type: Object,
            default: () => ({})
        },
    },
    components: {
        Icon,
    },
    data() {
        return {
            fromNative: "",
            navHeight: 0
        }
    },

    created() {

    },
    mounted() {
        const navHeightinSession = session.get('navHeight') || ''
        const navHeight = this.$route.query.navHeight || 0
        this.fromNative = this.$route.query.fromNative || ''

        if (navHeight) {
            this.navHeight = navHeight
            session.set('navHeight', navHeight)
        } else if (navHeightinSession) {
            this.navHeight = navHeightinSession
        }
    },

    methods: {
        back() {
            if (this.backPath) {
                this.$router.replace({ path: this.backPath, query: this.backQuery })
                return
            }
            if (this.forceRouterBack) {
                this.$router.back()
                return
            }
            // if (this.fromNative) {
            //     native.closeWebView()

            // } else {
            //     this.$router.back()
            // }
            const formPage = this.$route.query.formPage || ''
            if (hasNativeBridge()) {
                native.closeWebView()
            } else if (window.history.length > 1) {
                this.$router.back()
            } else if (this.$route.path === '/cycling/matchEnroll') {
                this.$router.replace({ path: '/cycling/raceDetail', query: { id: this.$route.query.id } })
            }
        },
        clickRight() {
            this.$emit("onClickRight")
        }
    },
}
</script>

<style lang="less" scoped>
.titleMain {
    overflow: hidden;
    position: fixed;
    background-color: #fff;
    // display: flex;
    // align-items: end;
    z-index: 9999;
}

.bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover; // 确保图片覆盖整个容器
    z-index: -1; // 将图片置于底层
}

.navTitle {
    // position: relative;
    text-align: left;
    color: #24243F;
    font-size: 18px;
    height: 50px;
    width: 100vw;
    line-height: 50px;

    img,
    .van-icon {
        width: 22px;
        height: 22px;
        position: absolute;
        left: 6px;
        top: 50%;
        transform: translateY(-50%);
    }


    .right {
        font-size: 16px;
        width: 100px;
        // height: 22px;
        position: absolute;
        right: 6px;
        top: 50%;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
    }

}

.navTitleTop {
    position: fixed;
    box-sizing: border-box;
    padding-left: 38px;
    text-align: left;
    color: #24243F;
    font-size: 18px;
    height: 50px;
    width: 100%;
    line-height: 50px;
    overflow: hidden;
    // background-color: #fff;
    z-index: 999;
}

.title {
    font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/Title.vue